import { Trans } from '@lingui/macro'
import { ButtonLight, ButtonPrimary, Flex } from 'front-end/src/components'
import IconArrowLeft from 'front-end/src/components/common/icon/IconArrowLeft'
import IconArrowRight from 'front-end/src/components/common/icon/IconArrowRight'
import React from 'react'
import { brandColors } from 'shared/basicPalette'

export const MultipageNavigationBar = ({
  currentElementIndex,
  setCurrentElement,
  canGoToNextElement
}) => {
  const commonButtonProps = {
    position: 'relative' as any,
    zIndex: 220,
    minW: '138px',
    size: 'lg',
    fontSize: '21px'
  }
  return (
    <Flex
      gridColumnGap="16px"
      position="absolute"
      bottom={0}
      w="100%"
      justify="center"
      py={['3px', '3px', '15px']}
      bgColor={[brandColors.grey.lightest, brandColors.grey.lightest, 'white']}
      borderTop="1px solid"
      borderColor={brandColors.grey.lighter}
    >
      {currentElementIndex > -1 && (
        <ButtonLight
          leftIcon={<IconArrowLeft />}
          onClick={() => {
            setCurrentElement(currentElementIndex - 1)
          }}
          {...commonButtonProps}
        >
          <Trans>Previous</Trans>
        </ButtonLight>
      )}

      {canGoToNextElement() && (
        <ButtonPrimary
          rightIcon={<IconArrowRight />}
          onClick={() => {
            setCurrentElement(currentElementIndex + 1)
          }}
          {...commonButtonProps}
        >
          <Trans>Next</Trans>
        </ButtonPrimary>
      )}
    </Flex>
  )
}
